// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './ExtendedStatusMessage';
export * from './ExtendedStatusMessage';



// WEBPACK FOOTER //
// ./components/ExtendedStatusMessage/index.js